var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPdW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 218.4 25.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:red;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,5.15A5.14,5.14,0,0,0,3.39,7.56V5.49H0V25.42H3.53V18.06A5.12,5.12,0,0,0,8,20.27a5.9,5.9,0,0,0,4.73-2.07,8.25,8.25,0,0,0,1.74-5.49A8.29,8.29,0,0,0,12.74,7.2,5.92,5.92,0,0,0,8,5.15Zm1.9,11a3.31,3.31,0,0,1-2.74,1.26,3.27,3.27,0,0,1-2.72-1.2,5.2,5.2,0,0,1-1-3.45,5.34,5.34,0,0,1,1-3.44A3.34,3.34,0,0,1,7.17,8.06,3.39,3.39,0,0,1,9.93,9.23a5.17,5.17,0,0,1,1,3.37A5.52,5.52,0,0,1,9.91,16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.82,8.06V5.49H16.41V19.94h3.53V12.6a4,4,0,0,1,1.07-3,4.34,4.34,0,0,1,3.1-1H25V5.32a5.71,5.71,0,0,0-.86-.06A4.35,4.35,0,0,0,19.82,8.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.7,5.15a7.1,7.1,0,0,0-5.32,2.07,7.45,7.45,0,0,0-2,5.49,7.42,7.42,0,0,0,2,5.49,7.1,7.1,0,0,0,5.32,2.07A7.07,7.07,0,0,0,38,18.2a7.51,7.51,0,0,0,2-5.49A7.48,7.48,0,0,0,38,7.2,7.1,7.1,0,0,0,32.7,5.15Zm2.76,11a3.37,3.37,0,0,1-2.76,1.22A3.37,3.37,0,0,1,30,16.16a5.26,5.26,0,0,1-1-3.45,5.23,5.23,0,0,1,1-3.44A3.35,3.35,0,0,1,32.7,8.06a3.37,3.37,0,0,1,2.76,1.22,5.31,5.31,0,0,1,1,3.43A5.29,5.29,0,0,1,35.46,16.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.62,9.35C48.79,12,48,14.43,47.35,16.74c-.86-2.87-1.62-5.33-2.27-7.36l-1.4-3.89H39.9l5.35,14.45h4.06L54.68,5.49H51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.8,
    y: 0.31,
    width: 3.47,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.78,
    y: 5.49,
    width: 3.53,
    height: 14.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.18,7.36a5.09,5.09,0,0,0-4.45-2.21A5.82,5.82,0,0,0,63,7.2a8.12,8.12,0,0,0-1.76,5.51A8.15,8.15,0,0,0,63,18.2a5.85,5.85,0,0,0,4.73,2.07,5.2,5.2,0,0,0,4.57-2.35v2h3.41V0H72.18Zm-.89,8.8a3.4,3.4,0,0,1-2.75,1.2,3.36,3.36,0,0,1-2.71-1.15,5,5,0,0,1-1-3.39,5.54,5.54,0,0,1,1-3.5,3.26,3.26,0,0,1,2.7-1.26,3.33,3.33,0,0,1,2.75,1.21,5.34,5.34,0,0,1,1,3.44A5.37,5.37,0,0,1,71.29,16.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.78,5.15A6.88,6.88,0,0,0,79.6,7.22a7.7,7.7,0,0,0-2,5.49,7.62,7.62,0,0,0,2,5.49,6.9,6.9,0,0,0,5.21,2.07A7.23,7.23,0,0,0,89.21,19a6,6,0,0,0,2.35-3.51H88.17a3.29,3.29,0,0,1-3.3,2.07,3.58,3.58,0,0,1-2.59-.94,4.36,4.36,0,0,1-1.16-2.79h10.8V13A8.14,8.14,0,0,0,90,7.31,6.64,6.64,0,0,0,84.78,5.15Zm-3.64,6.19C81.48,9,82.68,7.9,84.76,7.9a3.37,3.37,0,0,1,2.46.92,4.26,4.26,0,0,1,1.18,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.84,5.15a5.18,5.18,0,0,0-4.51,2.41V5.49H93.91V19.94h3.53v-8.1a3.66,3.66,0,0,1,.94-2.67,3.06,3.06,0,0,1,2.28-1A2.42,2.42,0,0,1,103.38,11v9h3.52V10.36a5.23,5.23,0,0,0-1.35-3.85A5,5,0,0,0,101.84,5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.15,16.62a3.39,3.39,0,0,1-2.17.71,3.1,3.1,0,0,1-2.58-1.19,5.39,5.39,0,0,1-1-3.43,5.43,5.43,0,0,1,.94-3.43A3.11,3.11,0,0,1,116,8.09a3.3,3.3,0,0,1,2.1.67,3.2,3.2,0,0,1,1.09,1.94h3.53a6,6,0,0,0-2.1-4A7,7,0,0,0,116,5.15,6.75,6.75,0,0,0,110.8,7.2a7.61,7.61,0,0,0-2,5.51,7.58,7.58,0,0,0,2,5.49A6.85,6.85,0,0,0,116,20.27a7,7,0,0,0,4.64-1.55,6,6,0,0,0,2.13-4.16h-3.53A3.13,3.13,0,0,1,118.15,16.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.4,
    y: 5.49,
    width: 3.53,
    height: 14.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.43,
    y: 0.31,
    width: 3.47,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.91,9.49c0-2.89-2-4.34-6-4.34s-6.29,1.64-6.49,4.93h3.47a2.39,2.39,0,0,1,.78-1.78,3.72,3.72,0,0,1,2.21-.52,3.55,3.55,0,0,1,2,.44,1.54,1.54,0,0,1,.61,1.36,1.35,1.35,0,0,1-.48,1.13,3.33,3.33,0,0,1-1.57.52l-2.18.19q-5.55.57-5.55,4.51a3.89,3.89,0,0,0,1.42,3.19,5.81,5.81,0,0,0,3.79,1.15,5.26,5.26,0,0,0,4.65-2.1,5.16,5.16,0,0,0,.39,1.77h3.53a4.94,4.94,0,0,1-.59-2.75Zm-3.41,4.73a3.3,3.3,0,0,1-1,2.62,3.91,3.91,0,0,1-2.69.91,2.74,2.74,0,0,1-1.8-.52,1.75,1.75,0,0,1-.63-1.44,1.71,1.71,0,0,1,.6-1.41,3.92,3.92,0,0,1,2-.66l1.9-.22a3.11,3.11,0,0,0,1.66-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.66,8.15a5.51,5.51,0,0,0-5.18-3,5.93,5.93,0,0,0-4.76,2.07,8,8,0,0,0-1.79,5.49,8,8,0,0,0,1.79,5.49,5.93,5.93,0,0,0,4.76,2.07,5.52,5.52,0,0,0,5.26-3.16v2.83h1.52V0h-1.6Zm-1.32,9a5,5,0,0,1-7.39,0,6.66,6.66,0,0,1-1.37-4.42A7.06,7.06,0,0,1,148,8.26a4.54,4.54,0,0,1,3.7-1.68,4.59,4.59,0,0,1,3.69,1.65,6.71,6.71,0,0,1,1.38,4.48A6.69,6.69,0,0,1,155.34,17.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.77,5.15A5.83,5.83,0,0,0,162,7.22a8.23,8.23,0,0,0-1.77,5.49A8.16,8.16,0,0,0,162,18.2a6,6,0,0,0,4.78,2.07,6,6,0,0,0,4-1.33,6.35,6.35,0,0,0,2.1-3.62h-1.65a4.49,4.49,0,0,1-1.52,2.56,4.41,4.41,0,0,1-2.88.94,4.58,4.58,0,0,1-3.57-1.45,6.32,6.32,0,0,1-1.41-4.13h11.34v-.56a8.35,8.35,0,0,0-1.71-5.4A5.77,5.77,0,0,0,166.77,5.15Zm-4.85,6.67A6.11,6.11,0,0,1,163.41,8a4.42,4.42,0,0,1,3.36-1.37A4.26,4.26,0,0,1,170.14,8a6.15,6.15,0,0,1,1.39,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.13,12l-1.45-.25a6.18,6.18,0,0,1-2.62-.95,2.08,2.08,0,0,1-.8-1.74,2.15,2.15,0,0,1,.94-1.87,4.46,4.46,0,0,1,2.64-.68,4.9,4.9,0,0,1,3,.76,3.06,3.06,0,0,1,1.09,2.35h1.63c-.13-3-2-4.48-5.72-4.48a6.11,6.11,0,0,0-3.8,1,3.45,3.45,0,0,0-1.38,2.9,3.4,3.4,0,0,0,1.11,2.67,6.88,6.88,0,0,0,3.43,1.42l1.48.25a6.79,6.79,0,0,1,2.75,1,2.06,2.06,0,0,1,.81,1.74q0,2.74-4,2.74c-2.73,0-4.18-1.15-4.37-3.44h-1.62A4.68,4.68,0,0,0,175.9,19a6.72,6.72,0,0,0,4.31,1.23,7,7,0,0,0,4.13-1.08,3.6,3.6,0,0,0,1.5-3.12,3.31,3.31,0,0,0-1.11-2.64A7.51,7.51,0,0,0,181.13,12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 187.46,
    y: 0.67,
    width: 1.68,
    height: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 187.52,
    y: 5.49,
    width: 1.6,
    height: 14.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.78,8.18a5.53,5.53,0,0,0-5.21-3,5.83,5.83,0,0,0-4.71,2.07,8.32,8.32,0,0,0-1.73,5.49,8.3,8.3,0,0,0,1.73,5.49,5.83,5.83,0,0,0,4.71,2.07,5.63,5.63,0,0,0,5.12-2.85v2q0,5-4.81,5-3.76,0-4.23-3.17h-1.57a4.71,4.71,0,0,0,1.72,3.31,6.35,6.35,0,0,0,4.08,1.2,6.42,6.42,0,0,0,4.78-1.65,6.44,6.44,0,0,0,1.63-4.73V5.49h-1.51Zm-1.38,9a4.81,4.81,0,0,1-7.28,0,6.94,6.94,0,0,1-1.34-4.45,6.94,6.94,0,0,1,1.34-4.45,4.81,4.81,0,0,1,7.28,0,6.81,6.81,0,0,1,1.35,4.48A6.79,6.79,0,0,1,201.4,17.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.05,6.52a5,5,0,0,0-3.78-1.37,5.22,5.22,0,0,0-4.81,3V5.49H207V19.94h1.59v-8.1a5.67,5.67,0,0,1,1.35-3.92A4.18,4.18,0,0,1,213,6.58q3.83,0,3.83,4v9.38h1.6V10.42A5.34,5.34,0,0,0,217.05,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.79,4h8a2,2,0,0,0,0-4h-8a2,2,0,0,0,0,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPdW);
export default __webpack_public_path__ + "static/media/Logo_PD_W.f0243b74bba6e0d4a9b9f7333e2f40db.svg";
export { ForwardRef as ReactComponent };